import {
  Box,
  TextField,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  styled,
  OutlinedInput,
  FormHelperText,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./addeditworkforce.css";
import { MuiTelInput } from "mui-tel-input";
import DatePickerMui from "../patient/DatePickerMui";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import { Spin } from "antd";
import { useRecoilValue } from "recoil";
import { currentConfiguration } from "../../../service/memory/recoil/configurationstore";
import ConfigurationConstants from "../../utils/configurationconstants";
import { strings } from "../../utils/strings";
import { executeIntent } from "../../utils/IntentExecutor";
import IntentType from "../../../intentexecutor/utils/IntentType";
import GoogleAddressSelect from "../patient/GoogleAddressSelect";
import TeamMultiselect from "../patient/TeamMultiselect";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const AddEditWorkforceFormComponent = ({
  workforceData,
  setWorkforceData,
  formErrors,
  invitationFormProps,
  workforceDetailsLoading,
  metadata,
  setMetadata,
  showAdditionalFields,
  setEmergencyContact,
  emergencyContact,
  disableEmail,
  label,
  isTeamRequired
}) => {
  const [showRoleSelection, setShowRoleSelection] = useState(false);
  const [options, setOptions] = useState({});
  const [optionsLoading, setOptionsLoading] = useState(false);
  const configuration = useRecoilValue(currentConfiguration);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const gender = ["Male", "Female", "Non Binary"];
  const roles = ["Volunteer", "Volunteer Coordinator"];
  const binary = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "isActive") {
      setWorkforceData((prevData) => ({
        ...prevData,
        isActive: value === "Active",
      }));
    } else {
      setWorkforceData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleMetadataChange = (e) => {
    const { name, value } = e.target;
    setMetadata((prev) => {
      const updatedMetadata = {
        ...prev,
        [name]: value,
      };

      // Update workforceData with the new metadata
      setWorkforceData((prevWorkforceData) => ({
        ...prevWorkforceData,
        metadata: JSON.stringify(updatedMetadata),
      }));

      return updatedMetadata; // Return the updated metadata for the setMetadata state
    });
  };

  const handleEmergencyContactChange = (e) => {
    const { name, value } = e.target;
    setEmergencyContact((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const inputFieldSyle = {
    "& .MuiOutlinedInput-root": {
      color: "#000",
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "var(--main-theme-color) !important",
          borderWidth: "1px !important",
        },
      },
    },
    "& .MuiInputLabel-outlined": {
      "&.Mui-focused": {
        color: "var(--main-theme-color) !important",
        borderWidth: "1px !important",
      },
    },
  };

  const CustomOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--main-theme-color) !important",
      borderWidth: "1px !important",
    },
  }));

  useEffect(() => {
    const configurationShowRole =
      configuration[
        ConfigurationConstants.NIRAMAYA_WORKFORCE_PROFILE_EDIT_ROLE
      ];
    setShowRoleSelection(configurationShowRole?.visibility);
  }, [configuration]);

  useEffect(() => {
    const getOptions = async () => {
      setOptionsLoading(true);
      const payload = {
        configurationKey: ["niramaya.add.patient.options"],
      };

      const result = await executeIntent(
        IntentType.GET_CONFIGURATION,
        payload,
        {},
      );
      const options =
        result[0].configurationValue &&
        JSON.parse(result[0].configurationValue);
      setOptions(options);
      setOptionsLoading(false);
    };

    if (showAdditionalFields) {
      getOptions();
    }
  }, [showAdditionalFields]);

  return (
    <div className="add-workforce-container">
      {workforceDetailsLoading || optionsLoading ? (
        <Spin size="medium" className="d-flex justify-content-center m-auto" />
      ) : (
        <>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              {showAdditionalFields && !invitationFormProps?.invitationForm && (
                <Grid xs={12} item>
                  <h6 className="add-edit-workforce-sub-header">
                    Workforce Primary Details
                  </h6>
                </Grid>
              )}

              {showAdditionalFields && showRoleSelection && (
                <Grid xs={6} item>
                  <FormControl fullWidth className="add-edit-select">
                    <InputLabel>{options?.workforceStatus?.label}</InputLabel>
                    <Select
                      name={options?.workforceStatus?.value}
                      onChange={handleChange}
                      value={
                        workforceData?.workforceStatus
                          ? workforceData?.workforceStatus
                          : workforceData?.isActive
                            ? "Active"
                            : "Inactive"
                      }
                      input={
                        <CustomOutlinedInput
                          label={options?.workforceStatus?.label}
                        />
                      }
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: ITEM_HEIGHT * 3.5 + ITEM_PADDING_TOP,
                            width: 230,
                          },
                        },
                      }}
                    >
                      {options?.workforceStatus?.menuItems?.map((item) => (
                        <MenuItem key={item?.label} value={item?.value}>
                          {item?.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {showRoleSelection && (
                <Grid xs={showAdditionalFields ? 6 : 12} item>
                  <FormControl
                    required
                    error={formErrors?.jobTitle}
                    sx={{ width: "100%" }}
                    className="add-edit-select"
                  >
                    <InputLabel>Role</InputLabel>
                    <Select
                      value={workforceData?.jobTitle || ""}
                      name="jobTitle"
                      onChange={handleChange}
                      fullWidth
                      disabled={invitationFormProps?.invitationForm}
                      input={<CustomOutlinedInput label="Role" />}
                    >
                      {roles?.map((item) => (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{formErrors?.jobTitle}</FormHelperText>
                  </FormControl>
                </Grid>
              )}
              <Grid xs={3} item>
                <TextField
                  fullWidth
                  value={workforceData?.pronoun}
                  name="pronoun"
                  label="Pronoun"
                  variant="outlined"
                  onChange={handleChange}
                  sx={inputFieldSyle}
                  InputLabelProps={{
                    shrink: workforceData?.pronoun,
                  }}
                />
              </Grid>
              <Grid xs={4.5} item>
                <TextField
                  error={formErrors?.givenName}
                  required
                  fullWidth
                  value={workforceData?.givenName}
                  name="givenName"
                  label={strings.FIRST_NAME}
                  variant="outlined"
                  helperText={formErrors?.givenName}
                  onChange={handleChange}
                  sx={inputFieldSyle}
                  InputLabelProps={{
                    shrink: workforceData?.givenName,
                  }}
                />
              </Grid>
              <Grid xs={4.5} item>
                <TextField
                  error={formErrors?.familyName}
                  required
                  fullWidth
                  value={workforceData?.familyName}
                  name="familyName"
                  label={strings.LAST_NAME}
                  variant="outlined"
                  helperText={formErrors?.familyName}
                  onChange={handleChange}
                  sx={inputFieldSyle}
                  InputLabelProps={{
                    shrink: workforceData?.familyName,
                  }}
                />
              </Grid>
              <Grid xs={12} sm={6} item>
                <DatePickerMui
                  data={workforceData}
                  setData={setWorkforceData}
                  inputFieldSyle={inputFieldSyle}
                  name="birthDate"
                  label="Date Of Birth"
                />
              </Grid>
              <Grid xs={12} sm={6} item>
                <FormControl sx={{ width: "100%" }} className="add-edit-select">
                  <InputLabel>{strings.GENDER}</InputLabel>
                  <Select
                    name="gender"
                    onChange={handleChange}
                    fullWidth
                    value={workforceData?.gender || ""}
                    input={<CustomOutlinedInput label={strings.GENDER} />}
                  >
                    {gender?.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={12} item>
                <TextField
                  error={formErrors?.email}
                  type="email"
                  required
                  fullWidth
                  value={workforceData?.email}
                  name="email"
                  label={strings.EMAIL}
                  variant="outlined"
                  disabled={invitationFormProps?.invitationForm || disableEmail}
                  helperText={formErrors?.email}
                  onChange={handleChange}
                  sx={inputFieldSyle}
                  InputLabelProps={{
                    shrink: workforceData?.email,
                  }}
                />
              </Grid>
              <Grid xs={12} item>
                <MuiTelInput
                  className="phone-input"
                  fullWidth
                  label="Phone"
                  forceCallingCode
                  defaultCountry="US"
                  value={workforceData?.telephone}
                  onChange={(value) =>
                    setWorkforceData((prev) => ({ ...prev, telephone: value }))
                  }
                  helperText={formErrors?.telephone}
                  error={formErrors?.telephone}
                  sx={inputFieldSyle}
                />
              </Grid>

              {!invitationFormProps?.invitationForm && showRoleSelection && (
                <Grid xs={12} item>
                  <TeamMultiselect
                    data={workforceData}
                    setData={setWorkforceData}
                    error={formErrors}
                    label={label}
                    required={isTeamRequired}
                  />
                </Grid>
              )}

              {(invitationFormProps?.invitationForm ||
                showAdditionalFields) && (
                <>
                  <Grid xs={12} item>
                    <GoogleAddressSelect
                      address={workforceData?.completeAddress}
                      setData={setWorkforceData}
                      errors={formErrors}
                      required={true}
                    />
                  </Grid>
                  {invitationFormProps?.invitationForm && (
                    <>
                      <Grid xs={12} item>
                        <TextField
                          fullWidth
                          value={metadata?.referral}
                          name="referral"
                          label={strings.REFERRAL}
                          onChange={handleMetadataChange}
                          sx={inputFieldSyle}
                          InputLabelProps={{
                            shrink: workforceData?.referral,
                          }}
                        />
                      </Grid>

                      <Grid xs={12} sm={6} item>
                        <TextField
                          error={formErrors?.password}
                          type={showPassword ? "text" : "password"}
                          required
                          fullWidth
                          value={workforceData?.password}
                          name="password"
                          label={strings.PASSWORD}
                          variant="outlined"
                          helperText={formErrors?.password}
                          onChange={handleChange}
                          sx={inputFieldSyle}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() =>
                                    setShowPassword((prev) => !prev)
                                  }
                                >
                                  {showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid xs={12} sm={6} item>
                        <TextField
                          error={formErrors?.confirmPassword}
                          type={showConfirmPassword ? "text" : "password"}
                          required
                          fullWidth
                          value={workforceData?.confirmPassword}
                          name="confirmPassword"
                          label={strings.CONFIRM_PASSWORD}
                          variant="outlined"
                          helperText={formErrors?.confirmPassword}
                          onChange={handleChange}
                          sx={inputFieldSyle}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle confirm password visibility"
                                  onClick={() =>
                                    setShowConfirmPassword((prev) => !prev)
                                  }
                                  edge="end"
                                >
                                  {showConfirmPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid xs={12} item>
                        <PrimaryButton
                          buttonText={strings.SIGNUP}
                          handleOnClick={invitationFormProps?.handleFormSave}
                          loading={invitationFormProps?.buttonLoader}
                          invitationForm={invitationFormProps?.invitationForm}
                        />
                      </Grid>
                    </>
                  )}
                </>
              )}

              {showAdditionalFields && (
                <>
                  <Grid xs={12} item>
                    <h6 className="add-edit-workforce-sub-header">
                      Employment Information
                    </h6>
                  </Grid>

                  <Grid xs={12} sm={6} item>
                    <DatePickerMui
                      data={workforceData}
                      setData={setWorkforceData}
                      name="anniversary"
                      label="Volunteer Anniversary"
                      inputFieldSyle={inputFieldSyle}
                    />
                  </Grid>
                  <Grid xs={12} sm={6} item>
                    <TextField
                      fullWidth
                      value={workforceData?.employeeCode}
                      className="add-edit-select"
                      name="employeeCode"
                      label={strings.EMPLOYEE_CODE}
                      onChange={handleChange}
                      sx={inputFieldSyle}
                      InputLabelProps={{
                        shrink: workforceData?.employeeCode,
                      }}
                    />
                  </Grid>
                  {workforceData?.jobTitle === "Volunteer Coordinator" && (
                    <>
                      <Grid xs={12} sm={6} item>
                        <FormControl
                          sx={{ width: "100%" }}
                          className="add-edit-select"
                        >
                          <InputLabel>{strings.PPC}</InputLabel>
                          <Select
                            name="isPPC"
                            onChange={handleChange}
                            fullWidth
                            value={workforceData?.isPPC ?? ""}
                            input={<CustomOutlinedInput label={strings.PPC} />}
                          >
                            {binary?.map((item) => (
                              <MenuItem key={item.label} value={item.value}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid xs={12} sm={6} item>
                        <FormControl
                          sx={{ width: "100%" }}
                          className="add-edit-select"
                        >
                          <InputLabel>{strings.FPC}</InputLabel>
                          <Select
                            name="isFPC"
                            onChange={handleChange}
                            fullWidth
                            value={workforceData?.isFPC ?? ""}
                            input={<CustomOutlinedInput label={strings.FPC} />}
                          >
                            {binary?.map((item) => (
                              <MenuItem key={item.label} value={item.value}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  )}
                  <Grid xs={12} sm={12} item>
                    <MuiTelInput
                      className="phone-input"
                      fullWidth
                      label="Work Phone"
                      forceCallingCode
                      defaultCountry="US"
                      value={metadata?.telephone}
                      onChange={(value) => {
                        const updatedMetadata = {
                          ...JSON.parse(workforceData?.metadata || "{}"),
                          telephone: value,
                        };
                        setWorkforceData({
                          ...workforceData,
                          metadata: JSON.stringify(updatedMetadata),
                        });
                        setMetadata((prev) => ({ ...prev, telephone: value }));
                      }}
                      sx={inputFieldSyle}
                    />
                  </Grid>

                  <Grid xs={12} item>
                    <h6 className="add-edit-workforce-sub-header">
                      Emergency Contact
                    </h6>
                  </Grid>

                  <Grid xs={6} item>
                    <TextField
                      fullWidth
                      value={emergencyContact?.givenName}
                      name="givenName"
                      label="First Name"
                      variant="outlined"
                      onChange={handleEmergencyContactChange}
                      sx={inputFieldSyle}
                    />
                  </Grid>
                  <Grid xs={6} item>
                    <TextField
                      fullWidth
                      value={emergencyContact?.familyName}
                      name="familyName"
                      label="Last Name"
                      variant="outlined"
                      onChange={handleEmergencyContactChange}
                      sx={inputFieldSyle}
                    />
                  </Grid>

                  <Grid xs={12} sm={6} item>
                    <MuiTelInput
                      fullWidth
                      defaultCountry="US"
                      value={emergencyContact?.telephone || ""}
                      forceCallingCode
                      onChange={(value) =>
                        setEmergencyContact((prev) => ({
                          ...prev,
                          telephone: value,
                        }))
                      }
                      sx={inputFieldSyle}
                    />
                  </Grid>

                  <Grid xs={12} sm={6} item style={{ marginTop: "-8px" }}>
                    <FormControl fullWidth className="add-edit-select">
                      <InputLabel>Relation</InputLabel>
                      <Select
                        name="relation"
                        onChange={handleEmergencyContactChange}
                        value={emergencyContact?.relation || ""}
                        input={<CustomOutlinedInput label="Relation" />}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                              width: 250,
                            },
                          },
                        }}
                      >
                        {options?.caregiverRelation?.menuItems?.map((item) => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </>
              )}

              {showAdditionalFields && showRoleSelection && (
                <Grid xs={12} item>
                  <TextField
                    fullWidth
                    value={workforceData?.comments}
                    multiline
                    rows={2}
                    name="comments"
                    label="Notes"
                    onChange={handleChange}
                    sx={{
                      height: "auto",
                      "& .MuiInputBase-root": { height: "auto" },
                    }}
                    InputLabelProps={{
                      shrink: workforceData?.comments,
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </>
      )}
    </div>
  );
};

export default AddEditWorkforceFormComponent;
